<template>
  <div class="container catalog-page">
    <block-breadcrumbs />

    <banners-slot
      class="bottom-offset"
      slot-name="transparency_category"
    />

    <page-head
      :title="CATEGORY_NAME"
      :info="subtitle"
      class="catalog-page__head"
    />

    <div class="body">
      <side-nav />
      <div class="content">
        <banners-slot
          class="bottom-offset"
          slot-name="rowbanner2_category"
        />

        <product-gallery-slot
          class="bottom-offset"
          slot-name="new_category"
        />

        <category-banners-slot
          class="bottom-offset"
        />

        <banners-slot
          class="bottom-offset"
          slot-name="rowbanner1_category"
        />

        <product-gallery-slot
          class="bottom-offset"
          slot-name="popular_category"
        />

        <banners-slot
          slot-name="rowbanner3_category"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import blockBreadcrumbs from '../components/breadcrumbs/breadcrumbs';
import sideNav from '../components/catalog/side-nav';
import PageHead from '../components/common/page-head.vue';
import ProductGallerySlot from '@/components/product-gallery-slot/product-gallery-slot.vue';
import BannersSlot from '@/components/banners-slot/banners-slot.vue';
import CategoryBannersSlot from '@/components/category-banners-slot/category-banners-slot.vue';
import { catalogGtmEvents } from '@/gtm/catalog-gtm-events';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'page-catalog',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.CATEGORY_NAME });
  },

  components: {
    sideNav,
    blockBreadcrumbs,
    PageHead,
    ProductGallerySlot,
    BannersSlot,
    CategoryBannersSlot,
  },

  mixins: [pageMetaMixin],

  provide: {
    maxGalleryProducts: 4,
  },

  computed: {
    ...mapGetters({
      PRODUCTS_COUNT: 'category/productsCount',
      CATEGORY_NAME: 'category/categoryName',
      CITY: 'user/city',
    }),
    subtitle() {
      return `
        ${this.PRODUCTS_COUNT}
        ${this.$options.filters.decl(this.PRODUCTS_COUNT, 'товар', ['', 'а', 'ов'])}
      `;
    }
  },

  mounted() {
    // Google Tag Manager event
    catalogGtmEvents.viewCatalogPage({
      cityName: this.CITY?.name,
      categoryId: this.$route.path,
    });
  },

  methods: {
    ...mapActions({
      LOAD_PAGE_DATA: 'category/loadData',
    }),
  },

  serverPrefetch () {
    return Promise.all([
      this.LOAD_PAGE_DATA(),
    ]);
  },
};
</script>

<style lang="scss">
.catalog-page {
  .body {
    display: flex;

    .content {
      flex: 1;
      max-width: 100%;
      overflow: hidden;

      @include breakpoint("desktop") {
        overflow: visible;
      }
    }
  }

  &__head {
    margin-bottom: 32px;

    @include breakpoint("tablet") {
      margin-bottom: 22px;
    }

    @include breakpoint("desktop") {
      margin-bottom: 40px;
    }
  }
}
</style>
